export const StarLineMobile = () => (
  <svg
    width="28"
    height="26"
    viewBox="0 0 28 26"
    className="inline mx-px my-0 align-baseline"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.9935 9.04498L18.7122 8.01998L15.4207 1.52833C14.8721 0.405716 13.1765 0.356906 12.578 1.52833L9.33634 8.01998L2.0052 9.04498C0.708531 9.24021 0.209814 10.8021 1.15738 11.7295L6.39391 16.7569L5.14712 23.8342C4.94763 25.1033 6.34404 26.0795 7.49109 25.4937L14.0243 22.1259L20.5076 25.4937C21.6547 26.0795 23.0511 25.1033 22.8516 23.8342L21.6048 16.7569L26.8413 11.7295C27.7889 10.8021 27.2902 9.24021 25.9935 9.04498ZM19.0115 15.9271L20.2084 22.6628L14.0243 19.4902L7.79032 22.6628L8.98724 15.9271L3.95019 11.1438L10.8824 10.1676L14.0243 4.01761L17.1163 10.1676L24.0485 11.1438L19.0115 15.9271Z"
      fill="#292B29"
    />
  </svg>
);
